import React, { Component } from 'react'
import {
    Container
} from 'reactstrap'
import './analytics.css'

export default class Analytics extends Component {

    render() {
        return (
            <Container className="containerAnalytics">
                <h2>Analytics</h2>
                <div className="divAnalytics">
                <div className="responsive-inline-frame">
                    <div className="responsive-inline-frame-inner">
                        <iframe
                            src="https://datastudio.google.com/embed/reporting/1bMFTzP1RP13yw82HBlsyfQ64wltSSe6B/page/jmKo"
                            frameBorder="0"
                            allowFullScreen>
                        </iframe>
                    </div>
                </div>
                </div>
                
            </Container>
        )
    }
}